import { CANON_IR1022_ABBINAMENTI } from './mockProductsCanonIR1022';

// =============================================
// ABBINAMENTI MACCHINA → PRODOTTI
// Mappa: idModello → lista SKU prodotti compatibili
// (equivalente a abb_AbbinamentiArticoli nel DB legacy)
// =============================================
export const ABBINAMENTI: Record<string, string[]> = {
  // Brother Mono
  'bro-hll2310':  ['TN-2420', 'DR-2400'],
  'bro-hll2350':  ['TN-2420', 'DR-2400'],
  'bro-hll2370':  ['TN-2420', 'DR-2400'],
  'bro-mfcl2710': ['TN-2420', 'DR-2400'],
  'bro-mfcl2750': ['TN-2420', 'DR-2400'],
  'bro-hll5000':  ['TN-3480'],
  'bro-mfcl5700': ['TN-3480'],
  // Brother Colore
  'bro-hll3210':  ['TN-247BK', 'TN-247C', 'TN-247M', 'TN-247Y', 'KIT-TN247'],
  'bro-hll3230':  ['TN-247BK', 'TN-247C', 'TN-247M', 'TN-247Y', 'KIT-TN247'],
  'bro-mfcl3770': ['TN-247BK', 'TN-247C', 'TN-247M', 'TN-247Y', 'KIT-TN247'],
  // Brother Inkjet
  'bro-dcpj572':  ['LC-3211BK', 'LC-3211C', 'LC-3211M', 'LC-3211Y'],
  'bro-mfcj491':  ['LC-3211BK', 'LC-3211C', 'LC-3211M', 'LC-3211Y'],
  'bro-mfcj1300': ['LC-3213BK', 'LC-3213C', 'LC-3213M', 'LC-3213Y'],
  // HP Mono
  'hp-m304':  ['CF259A', 'CF259X', 'CF232A'],
  'hp-m404':  ['CF259A', 'CF259X', 'CF232A'],
  'hp-m428':  ['CF259A', 'CF259X', 'CF232A'],
  'hp-p1102': ['CE285A'],
  'hp-m102':  ['CF217A'],
  'hp-m227':  ['CF230A', 'CF232A'],
  // HP Colore
  'hp-m454':  ['W2030A', 'W2031A'],
  'hp-m479':  ['W2030A', 'W2031A'],
  // HP Inkjet
  'hp-oj7720': ['T405XL'],
  'hp-oj9020': ['T405XL'],
  'hp-dj2710': ['305BK', '305C'],
  // HP LaserJet 1022
  'hp-lj1022':   ['Q2612A'],
  'hp-lj1022n':  ['Q2612A'],
  'hp-lj1022nw': ['Q2612A'],
  // Canon — abbinamenti completi
  'can-ir-c3320': ['C-EXV49BK', 'C-EXV49C', 'C-EXV49M', 'C-EXV49Y', 'KIT-C-EXV49'],
  'can-ir-c3325': ['C-EXV49BK', 'C-EXV49C', 'C-EXV49M', 'C-EXV49Y', 'KIT-C-EXV49'],
  'can-lbp621':   ['054BK', '054HBK', '054C', '054HC', '054M', '054HM', '054Y', '054HY', 'KIT-054H', '054-DRUM'],
  'can-mf641':    ['054BK', '054HBK', '054C', '054HC', '054M', '054HM', '054Y', '054HY', 'KIT-054H', '054-DRUM'],
  'can-lbp623':   ['054BK', '054HBK', '054C', '054HC', '054M', '054HM', '054Y', '054HY', 'KIT-054H', '054-DRUM'],
  'can-mf645':    ['054BK', '054HBK', '054C', '054HC', '054M', '054HM', '054Y', '054HY', 'KIT-054H', '054-DRUM'],
  'can-pxtr7550': ['PGI-580BK', 'CLI-581BK'],
  'can-pxts8150': ['PGI-580BK', 'CLI-581BK'],
  'can-ir2016':   ['C-EXV14', 'C-EXV14-DRUM', 'C-EXV14-DRUM2', 'FM2-5533-100', 'FB2-8036-010', 'KIT-IR2020-BASE', 'KIT-IR2020-FULL'],
  'can-ir2018':   ['C-EXV14', 'C-EXV14-DRUM', 'FM2-5533-100', 'FB2-8036-010', 'KIT-IR2020-BASE'],
  'can-ir2020':   ['C-EXV14', 'C-EXV14-DRUM', 'FM2-5533-100', 'FB2-8036-010', 'KIT-IR2020-BASE', 'KIT-IR2020-FULL'],
  'can-ir2022':   ['C-EXV14', 'C-EXV14-DRUM', 'FM2-5533-100', 'FB2-8036-010', 'KIT-IR2020-BASE'],
  'can-ir2025':   ['C-EXV14', 'C-EXV14-DRUM', 'FM2-5533-100', 'FB2-8036-010', 'KIT-IR2020-BASE', 'KIT-IR2020-FULL'],
  'can-ir2030':   ['C-EXV14', 'C-EXV14-DRUM', 'FM2-5533-100', 'FB2-8036-010', 'KIT-IR2020-BASE', 'KIT-IR2020-FULL'],
  'can-ir4025':   ['C-EXV39', 'C-EXV40', 'FM4-8400-010', 'RM1-8073-010'],
  'can-ir4035':   ['C-EXV39', 'C-EXV40', 'FM4-8400-010', 'RM1-8073-010'],
  'can-ir3035':   ['C-EXV12'],
  'can-ir3045':   ['C-EXV12'],
  'can-lbp6000':  ['725'],
  'can-lbp6200':  ['726'],
  'can-mf3010':   ['725'],
  'can-mf4410':   ['726', '728'],
  'can-mf211':    ['737', '737H'],
  'can-mf216':    ['737', '737H'],
  'can-mf226':    ['737', '737H'],
  'can-lbp162':   ['051', '051H', '051-DRUM'],
  'can-mf267':    ['051', '051H', '051-DRUM'],
  'can-ir1018':   ['C-EXV18', 'C-EXV18-HC', 'C-EXV18-DRUM', 'C-EXV18-KIT', 'FM2-5533-000', 'FM2-5538-000', 'FC6-7083-000', 'FC6-7082-000', 'FB2-8036-000', 'FB2-8041-000', 'FM2-5617-000', 'KIT-IR1022-BASE'],
  'can-ir1018j':  ['C-EXV18', 'C-EXV18-HC', 'C-EXV18-DRUM', 'FM2-5533-000', 'FM2-5538-000', 'FC6-7083-000', 'KIT-IR1022-BASE'],
  'can-ir1019':   ['C-EXV18', 'C-EXV18-HC', 'C-EXV18-DRUM', 'FM2-5533-000', 'FM2-5538-000', 'FC6-7083-000', 'KIT-IR1022-BASE'],
  'can-ir1019j':  ['C-EXV18', 'C-EXV18-HC', 'C-EXV18-DRUM', 'FM2-5533-000', 'FM2-5538-000', 'FC6-7083-000', 'KIT-IR1022-BASE'],
  'can-irc1021':  ['C-EXV26BK', 'C-EXV26C', 'C-EXV26M', 'C-EXV26Y', 'C-EXV26-KIT', 'C-EXV26-DRUM', 'FM3-0219-000', 'FM3-0220-000', 'FL3-3045-000', 'FM3-4099-000', 'RM1-5476-000', 'KIT-IRC1022-FULL'],
  'can-irc1021i': ['C-EXV26BK', 'C-EXV26C', 'C-EXV26M', 'C-EXV26Y', 'C-EXV26-KIT', 'C-EXV26-DRUM', 'FM3-0219-000', 'FM3-0220-000', 'FM3-4099-000', 'RM1-5476-000', 'KIT-IRC1022-FULL'],
  'can-irc1028':  ['C-EXV26BK', 'C-EXV26C', 'C-EXV26M', 'C-EXV26Y', 'C-EXV26-KIT', 'C-EXV26-DRUM', 'FM3-0219-000', 'FM3-0220-000', 'FL3-3045-000', 'FM3-4099-000', 'RM1-5476-000', 'KIT-IRC1022-FULL'],
  'can-irc1028i': ['C-EXV26BK', 'C-EXV26C', 'C-EXV26M', 'C-EXV26Y', 'C-EXV26-KIT', 'C-EXV26-DRUM', 'FM3-0219-000', 'FM3-0220-000', 'FM3-4099-000', 'RM1-5476-000', 'KIT-IRC1022-FULL'],
  // Canon IR 1022 — abbinamenti dal file dedicato (toner+drum+ricambi completi)
  ...CANON_IR1022_ABBINAMENTI,
  // Kyocera
  'kyo-m2040':  ['TK-1170'],
  'kyo-m2540':  ['TK-1170'],
  'kyo-m5526':  ['TK-5240K', 'TK-5240C'],
  'kyo-p2235':  ['TK-1150'],
  'kyo-m2035':  ['TK-1140'],
  'kyo-fs1022': ['TK-18'],
  'kyo-fs1030': ['TK-120'],
  'kyo-tk1140': ['TK-1140'],
  // Ricoh
  'ric-mpc2503': ['MP C2503'],
  'ric-mpc3503': ['MP C3003'],
  'ric-mp4000':  ['MP4000-T'],
  'ric-mp2852':  ['MP2852-T'],
  'ric-af1022':  ['TYPE-1220D'],
  'ric-af1027':  ['TYPE-1220D'],
  'ric-af1032':  ['TYPE-1220D'],
  'ric-af2015':  ['TYPE-1230D'],
  'ric-af2018':  ['TYPE-1230D'],
  'ric-sp3600':  ['SP3600-T'],
  // Xerox
  'xer-ph6510': ['106R03480', '106R03692'],
  'xer-wc6515': ['106R03480', '106R03692'],
  'xer-ph3330': ['106R03620'],
  'xer-wc3335': ['106R03620'],
  'xer-vc500':  ['106R03876'],
  // Samsung
  'sam-c430': ['CLT-K504S'],
  'sam-c480': ['CLT-K504S'],
  'sam-clp680': ['CLT-K506L'],
  // Toshiba
  'tos-2040c':  ['T-FC415E'],
  'tos-2540c':  ['T-FC415E'],
  'tos-mj1022': ['T-1022'],
  // OKI
  'oki-c332': ['46508712'],
  'oki-b411': ['44574702'],
  // Epson
  'eps-sx200':  ['T0711', 'T0712', 'T0713', 'T0714'],
  'eps-wf3620': ['T2711'],
  'eps-wf4820': ['T405XL'],
  // Lexmark
  'lex-ms410': ['50F2H00'],
  'lex-ms610': ['50F2H00'],
  'lex-b2236': ['B222000'],
  // Konica Minolta
  'kon-c224': ['TN-321K'],
  'kon-c364': ['TN-321K'],
  // Olivetti
  'oli-mf2400': ['B0946'],
  'oli-mf3000': ['B0946'],
};

// =============================================
// COMPATIBILITY EXPORTS
// Export di compatibilità per i componenti esistenti
// =============================================
import { SAMPLE_PRODUCTS } from './siteData';

// Re-export tipi dal types file
export type { RMARequest, Order, PrinterModel, MacchinaCliente } from '../types';

// Corrieri disponibili
export interface Carrier {
  id: string;
  name: string;
  code: string;
  logo?: string;
  description: string;
  estimatedDays: string;
  active: boolean;
  isDefault?: boolean;
}

export const CARRIERS: Carrier[] = [
  { id: 'brt', name: 'BRT - Bartolini', code: 'BRT', logo: '/carriers/brt.svg', description: 'Consegna Standard 24/48h', estimatedDays: '1-2 giorni lavorativi', active: true, isDefault: true },
  { id: 'gls', name: 'GLS Italy', code: 'GLS', logo: '/carriers/gls.svg', description: 'Consegna Standard 24/48h', estimatedDays: '1-2 giorni lavorativi', active: true },
  { id: 'ups', name: 'UPS Express', code: 'UPS', logo: '/carriers/ups.svg', description: 'Consegna Express 24h', estimatedDays: 'Giorno successivo', active: true },
  { id: 'dhl', name: 'DHL Express', code: 'DHL', logo: '/carriers/dhl.svg', description: 'Consegna Internazionale', estimatedDays: '1-3 giorni', active: false },
];

// Punti ritiro Cash & Carry
export interface CashCarryLocation {
  id: string;
  name: string;
  address: string;
  city: string;
  province: string;
  hours: string;
  active: boolean;
  phone: string;
  cap: string;
}

export const CASH_CARRY_LOCATIONS: CashCarryLocation[] = [
  { id: 'dtk-roma', name: 'DTK S.r.l. - Sede Roma', address: 'Via Acuto 52/b', city: 'Roma', province: 'RM', hours: 'Lun-Ven 9:00-18:30', active: true, phone: '+39 06 4182651', cap: '00131' },
];

// Banner promozionale
export const PROMO_BANNER = {
  text: 'PROMO MARZO: -15% su tutti i tamburi OPC Drum — Solo fino al 31/03',
  code: 'DRUM15',
  link: '/prodotti/opc-drum',
  cta: 'Scopri ora',
  endDate: '2026-03-31',
  // Barra disattivata su richiesta cliente (rimossa temporaneamente, dati/testo conservati per riattivazione futura)
  active: false,
};

// Promozioni in evidenza per homepage

// Stock prodotti (Record<sku, qty>)
export const PRODUCT_STOCK: Record<string, number> = Object.fromEntries(
  SAMPLE_PRODUCTS.map(p => {
    const outOfStock = ['TN-247C', 'DK-5140', 'D089-2251', 'NPG-32', 'GPR-22', 'FM2-5538-000', 'C-EXV26M', 'C-EXV26Y', 'FB2-8036-000'].includes(p.sku);
    const lowStock = ['TN-3480', 'B0946', 'T0715', 'T1285'].includes(p.sku);
    const highStock = ['TN-2420', 'CF259A', 'CE285A', 'HP 305XL', 'HP 302XL', 'LC-3213', 'TK-1170'].includes(p.sku);
    const qty = outOfStock ? 0 : lowStock ? Math.floor(Math.random() * 5) + 1 : highStock ? Math.floor(Math.random() * 100) + 50 : Math.floor(Math.random() * 40) + 10;
    return [p.sku, qty];
  })
);

// Codici OEM multipli per prodotto (alcuni prodotti hanno più codici OEM equivalenti)
export const PRODUCT_OEM_CODES: Record<string, string[]> = {
  'C-EXV14': ['C-EXV14', '0384B006AA', '0384B006', 'GPR-18', 'NPG-28'],
  'C-EXV18': ['C-EXV18', '0386B002AA', '0386B002', 'GPR-22'],
  'CE285A':  ['CE285A', 'CB435A', 'CB436A', 'CE278A'],
  'CF259A':  ['CF259A', 'CF259X'],
  'CF259X':  ['CF259X', 'CF259A'],
  'TN-2420': ['TN-2420', 'TN-2410'],
  'TN-3480': ['TN-3480', 'TN-3430'],
  'TK-1170': ['TK-1170', 'TK-1160'],
  'Q2612A':  ['Q2612A', 'FX-10', 'FX-9', '703'],
  'TK-18':   ['TK-18', 'TK-17', 'TK-100'],
};


// Sconto Scatola — re-export per retro-compatibilità.
// Il vero data layer è ora in `data/boxDiscount.ts` (registry runtime
// alimentato dal backend via productService.normalizeProduct).
export { PRODUCT_BOX_DISCOUNTS, calcBoxPrice } from './boxDiscount';


